import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { InputAdornment, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';
import React from 'react';

export type UnitKey = 'hq' | 'src' | 'dst';
export type FieldKey = 'Unit' | 'LastName' | 'FirstName' | 'Tel' | 'Mail';
export type TouchedKey = `${UnitKey}${FieldKey}`;

export type UnitContactFieldsProps = {
    unitKey: UnitKey;
    unitName: string;
    setUnitName: (value: string) => void;
    lastName: string;
    setLastName: (value: string) => void;
    firstName: string;
    setFirstName: (value: string) => void;
    tel: string;
    setTel: (value: string) => void;
    mail: string;
    setMail: (value: string) => void;
    touched: Record<TouchedKey, boolean>;
    markTouched: (key: TouchedKey) => void;
    requiredMessage: string;
};

export const UnitContactFields = ({
    unitKey,
    unitName,
    setUnitName,
    lastName,
    setLastName,
    firstName,
    setFirstName,
    tel,
    setTel,
    mail,
    setMail,
    touched,
    markTouched,
    requiredMessage,
}: UnitContactFieldsProps) => {
    const unitTouchedKey = `${unitKey}Unit` as TouchedKey;
    const lastNameTouchedKey = `${unitKey}LastName` as TouchedKey;
    const firstNameTouchedKey = `${unitKey}FirstName` as TouchedKey;
    const telTouchedKey = `${unitKey}Tel` as TouchedKey;
    const mailTouchedKey = `${unitKey}Mail` as TouchedKey;

    const unitMissing = unitName.trim() === '';
    const lastNameMissing = lastName.trim() === '';
    const firstNameMissing = firstName.trim() === '';
    const mailMissing = mail.trim() === '';

    return (
        <React.Fragment>
            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    required
                    label="部隊名 / 所属"
                    value={unitName}
                    onChange={(e) => setUnitName(e.target.value)}
                    onBlur={() => markTouched(unitTouchedKey)}
                    error={touched[unitTouchedKey] && unitMissing}
                    helperText={touched[unitTouchedKey] && unitMissing ? requiredMessage : undefined}
                />
            </Grid>
            <Grid item xs={6} sm={3}>
                <TextField
                    fullWidth
                    required
                    label="姓"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    onBlur={() => markTouched(lastNameTouchedKey)}
                    error={touched[lastNameTouchedKey] && lastNameMissing}
                    helperText={touched[lastNameTouchedKey] && lastNameMissing ? requiredMessage : undefined}
                />
            </Grid>
            <Grid item xs={6} sm={3}>
                <TextField
                    fullWidth
                    required
                    label="名"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    onBlur={() => markTouched(firstNameTouchedKey)}
                    error={touched[firstNameTouchedKey] && firstNameMissing}
                    helperText={touched[firstNameTouchedKey] && firstNameMissing ? requiredMessage : undefined}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    required
                    label="メールアドレス"
                    value={mail}
                    onChange={(e) => setMail(e.target.value)}
                    onBlur={() => markTouched(mailTouchedKey)}
                    type="email"
                    error={touched[mailTouchedKey] && mailMissing}
                    helperText={touched[mailTouchedKey] && mailMissing ? requiredMessage : undefined}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <EmailOutlinedIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    label="電話番号"
                    value={tel}
                    onChange={(e) => setTel(e.target.value)}
                    onBlur={() => markTouched(telTouchedKey)}
                    inputMode="tel"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LocalPhoneOutlinedIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
        </React.Fragment>
    );
}
